import { render, staticRenderFns } from "./PurchaseCreate.vue?vue&type=template&id=09bb3c05&scoped=true"
import script from "./PurchaseCreate.vue?vue&type=script&lang=js"
export * from "./PurchaseCreate.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCreate.vue?vue&type=style&index=0&id=09bb3c05&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bb3c05",
  null
  
)

export default component.exports